import { UnlockIcon } from '@primer/octicons-react'
import clsx from 'clsx'
import React, { useContext } from 'react'

import SignoutTrigger from '@/components/shared/components/module/auth/SignoutTrigger'
import OrganizationAvatar from '@/components/shared/components/OrganizationAvatar'
import Button from '@/components/shared/ui/Button/Button'
import Typography from '@/components/shared/ui/Typography'
import HNContext from '@/context/HNContext'
import { useTranslations } from '@/hooks/useTranslations'
import { signinPath } from '@/lib/helpers/pathHelpers'
import { templateComponentReplace } from '@/lib/helpers/stringHelpers'

export default function RestrictedAccess() {
  const { organization, userProfile } = useContext(HNContext)
  const t = useTranslations('common.messages.pageMessages.forbidden')

  return (
    <div className='mx-auto flex h-screen flex-col place-content-center items-center text-center'>
      <div className={clsx('max-w-md space-y-3 border-b border-gray5 pb-4 ')}>
        {organization && (
          <div className='flex justify-center'>
            <OrganizationAvatar size='xl' organization={organization} />
          </div>
        )}
        <Typography.Title level={3}>
          {organization
            ? t('title', { data: { orgName: organization?.name } })
            : t('withoutOrgtitle')}
        </Typography.Title>
        {userProfile && (
          <Button size='xs' as='a' href={'/'}>
            {t('common.messages.pageMessages.fourNotFour.cta', {
              ignorePrefix: true,
            })}
          </Button>
        )}
        {!userProfile && (
          <Button size='xs' as='a' href={signinPath}>
            {t('buttons.login', {
              ignorePrefix: true,
            })}
          </Button>
        )}
      </div>
      <p className='pt-4 text-sm text-gray9 '>
        {userProfile
          ? templateComponentReplace(t('message'), {
              userMail: (
                <>
                  <span className='font-medium text-carbon '>
                    {userProfile?.email}
                  </span>
                  <br />
                </>
              ),
            })
          : t('withOutLoginMessage')}
      </p>
      {userProfile && (
        <div className='flex cursor-pointer space-x-2 pt-4 text-sm text-gray9 '>
          <SignoutTrigger as='div'>
            <div className='flex space-x-1'>
              <UnlockIcon />
              <Typography.Text className='font-medium'>
                {t('auth.labels.signOut', { ignorePrefix: true })}
              </Typography.Text>
            </div>
          </SignoutTrigger>
        </div>
      )}
    </div>
  )
}
